import React from "react";

const Identyti = () => {
  return (
    <div className="container-identity">
      <ul>
        <div className="first-li-container">
          <li>
            Nom : <span>Beni Biantuadi</span>
          </li>
          <br />
          <li>
            Age : <span>22 ans</span>
          </li>
        </div>
        <div className="first-li-container">
          <li>
            Ville : <span>Nancy, France</span>
          </li>
          <br />
          <li>
            Job : <span>Développeur fullstack</span>
          </li>
        </div>
      </ul>
    </div>
  );
};

export default Identyti;
